<template>
  <div>
    <table-view
      ref="tableList"
      :isSearchLoading="isAllLoad"
      :searchModel="searchModel"
      :tableModel="tableModel"
      :tableData="tableData"
      :pages="page"
      @searchChange="handleSearchChange"
      @pageChange="pageChange"
      tableCardTitle="All Request History"
      :isSearchRow="false"
      :isTableLoading="isTableLoading"
    >
      <template v-slot:bpmId="{ tableRow }">
        <a href="javascript:void(0)" @click="handleHrefInfoPage(tableRow.row)">
          {{ tableRow.row.bpmId }}
        </a>
      </template>
      <template v-slot:finishDate="{ tableRow }">
        {{
          tableRow.row.status === 3
            ? tableRow.row.approveDate
            : tableRow.row.finishDate
        }}
      </template>
      <template v-slot:action="{ tableRow }">
        <a href="javascript:void(0)" @click="handleAction(tableRow.row)">
          <i class="el-icon-check"></i>
        </a>
      </template>
      <template v-slot:customerType="{ tableRow }">
        {{
          tableRow.row.customerType === 1
            ? 'Trade'
            : tableRow.row.customerType === 2
            ? 'Eaas'
            : 'Saas'
        }}
      </template>
    </table-view>
  </div>
</template>

<script>
import { getTableList, getCssDetail } from './api'
import { getSelectList } from '@/api'
import dayjs from 'dayjs'
const selectList = ['Country', 'Region', 'CCA', 'Business', 'GEO']
const STATUS = [
  { id: 1, name: 'Pending' },
  { id: 2, name: 'Manual Approved' },
  { id: 3, name: 'Declined' },
  { id: 4, name: 'Cancelled' },
  { id: 6, name: 'Conditional Approval' },
  { id: 8, name: 'Field Action' },
]
export default {
  name: 'query',
  data() {
    const searchModel = [
      { label: 'Trans#', type: 'input', key: 'bpmId' },
      {
        label: 'Customer#',
        type: 'input',
        key: 'companyCode',
        defaultValue: '',
      },
      { label: 'Customer Name', type: 'input', key: 'companyName' },
      { label: 'GEO', type: 'select', key: 'geo', selectList: [] },
      { label: 'Region', type: 'select', key: 'region', selectList: [] },
      {
        label: 'Credit Category',
        type: 'select',
        key: 'creditCategory',
        selectList: [
          {
            id: 1,
            name: 'BAU',
          },
          {
            id: 2,
            name: 'Uplift',
          },
          {
            id: 3,
            name: 'Extension',
          },
          {
            id: 4,
            name: 'PCR',
          },
          {
            id: 5,
            name: 'Condition Update',
          },
          {
            id: 6,
            name: 'Waiver',
          },
          {
            id: 7,
            name: 'Invoice Extension',
          },
        ],
      },
      {
        label: 'Status',
        type: 'select',
        key: 'status',
        selectList: [
          { id: 1, name: 'Pending' },
          { id: 2, name: 'Manual Approved' },
          { id: 3, name: 'Declined' },
          { id: 4, name: 'Cancelled' },
          { id: 5, name: 'Waiting Auto Rules' },
          { id: 7, name: 'Auto Approved' },
        ],
      },{
        label: 'Customer Type',
        type: 'select',
        key: 'customerType',
        selectList: [
          {
            id: 1,
            name: 'Trade',
          },
          {
            id: 2,
            name: 'Eaas',
          },
          {
            id: 3,
            name: 'Saas',
          },
        ],
      },
    ]
    const tableModel = [
      { slotName: 'bpmId', label: 'Trans#' },
      { prop: 'companyCode', label: 'Customer#' },
      { prop: 'typeStr', label: 'Credit Category', width: 200 },
      { prop: 'companyName', label: 'Customer Name', width: 200 },
      { slotName: 'customerType', label: 'Customer Type', width: 200 },
      { slotName: 'finishDate', label: 'Decision Date', width: 200 },
      { prop: 'approver', label: 'Assigned To' },
      // { prop: 'priorityStr', label: 'Priority' },
      { prop: 'applier', label: 'Requestor' },
      { prop: 'approveAmount', label: 'Amount(USD)' },
      { label: 'GEO', prop: 'geo' },
      { prop: 'region', label: 'Region' },
      { prop: 'statusStr', label: 'Status' },
      // { label: 'Action', slotName: 'action' },
    ]
    return {
      searchModel,
      tableModel,
      tableData: [],
      page: {},
      selectType: 'Region',
      isAllLoad: true,
      isTableLoading: true,
    }
  },
  created() {
    // 获取下拉列表
    this.getAllSelect()
  },
  mounted() {
    if (this.$store.state.source === 2) {
      this.tableModel.splice(4, 1)
    }

    const code = this.$route.query.code
    if (code) {
      this.searchModel.forEach(item => {
        item.key === 'companyCode'
          ? (item.defaultValue = code)
          : (item.defaultValue = '')
      })
      const searchForm = this.$refs.tableList.getSearchForm()
      searchForm.companyCode = code
      const _params = {
        ...searchForm,
        current: 1,
        size: 10,
      }
      this._getTableList(_params)
    } else {
      const params = {
        current: 1,
        size: 10,
      }
      this._getTableList(params)
    }
  },
  methods: {
    async _getTableList(params) {
      try {
        this.isTableLoading = true
        const res = await getTableList(params)
        const { data, page } = res
        if (this.$store.state.source === 1) {
          data.forEach(item => {
            item.source = 'lenovo'
          })
        } else {
          data.forEach(item => {
            item.source = 'CSS'
          })
          this.searchModel[6].selectList = STATUS
        }
        this.tableData = data
        this.tableData.map(item => {
          item.approveAmount = this.$utils.formatAmount(item.approveAmount)
          if (item.approveDate) {
            item.approveDate = dayjs(item.approveDate).format('YYYY-MM-DD')
          }
          if (item.finishDate) {
            item.finishDate = dayjs(item.finishDate).format('YYYY-MM-DD')
          }
        })
        this.page = page
        this.isTableLoading = false
      } catch (err) {
        console.log(err)
      }
    },
    getAllSelect() {
      const pro = selectList.map(item => this._getSelectList(item))
      Promise.all(pro)
        .then(res => {
          if (res.length === selectList.length) {
            const [countryList, regionList, ccaList, businessList, GeoList] =
              res
            for (let i = 0; i < this.searchModel.length; i++) {
              const item = this.searchModel[i]
              if (item.label === 'Region') {
                item['selectList'] = regionList
              } else if (item.label === 'Country') {
                item['selectList'] = countryList
              } else if (item.label === 'CCA') {
                item['selectList'] = ccaList
              } else if (item.label === 'Business') {
                item['selectList'] = businessList
              } else if (item.label === 'GEO') {
                item['selectList'] = GeoList
              }
            }
            this.isAllLoad = false
          }
        })
        .catch(err => {
          console.log(`search 列表查询错误:${err}`)
        })
    },
    // 每个type遍历请求
    async _getSelectList(typeMark) {
      try {
        return await getSelectList(typeMark)
      } catch (err) {
        console.log(err)
      }
    },

    // search click callback
    handleSearchChange(params) {
      params.current = 1
      this._getTableList(params)
    },
    // 分页器页码改变
    pageChange(params) {
      this._getTableList({ ...params })
    },
    // goto audit
    async handleHrefInfoPage(tableRow) {
      this.$storage.setItem('bpmId', tableRow.bpmId)
      if (this.$store.state.source === 2) {
        // CSS
        // 根据status跳转;1为pending状态(跳到final);6为condition approved状态(跳到二次审核)
        const params = {
          bpmId: tableRow.bpmId || this.$storage.getItem('bpmId'),
        }
        const { running, creditInfo, additionalConditionsVOList, process } =
          await getCssDetail(params)
        if ([6, 8].includes(creditInfo.status)) {
          let routeUrl = this.$router.resolve({
            path: `/credit-management/css-audit/css-second-audit?bpmId=${tableRow.bpmId}&companyCode=${tableRow.companyCode}&status=${creditInfo.status}`, // 对应路由
          })
          window.open(routeUrl.href, '_blank')
        } else if (
          (creditInfo.status === 1 &&
            additionalConditionsVOList.length === 0 &&
            process.length === 2) ||
          (creditInfo.decisionType === 1 &&
            additionalConditionsVOList.length !== 0 &&
            running === 1) ||
          (creditInfo.decisionType === 4 &&
            creditInfo.status === 1 &&
            additionalConditionsVOList.length !== 0 &&
            running === 1) ||
          running === 1
        ) {
          // pending
          let routeUrl = this.$router.resolve({
            path: `/credit-management/css-audit/single-audit?bpmId=${tableRow.bpmId}&companyCode=${tableRow.companyCode}`, // 对应路由
          })
          window.open(routeUrl.href, '_blank')
        } else {
          let routeUrl = this.$router.resolve({
            path: `/credit-management/css-audit/css-final-audit?bpmId=${tableRow.bpmId}&companyCode=${tableRow.companyCode}`, // 对应路由
          })
          window.open(routeUrl.href, '_blank')
        }
        return
      }
      let routeUrl = this.$router.resolve({
        path: `/credit-management/credit-audit/single-audit?bpmId=${tableRow.bpmId}&companyCode=${tableRow.companyCode}`, // 对应路由
      })
      window.open(routeUrl.href, '_blank')
    },
  },
}
</script>

<style scoped>
.el-icon-check {
  color: black;
}
</style>
